var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingbag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Linear/shoppingbag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.00002 5.41666H13C15.8334 5.41666 16.1167 6.74166 16.3084 8.35832L17.0584 14.6083C17.3 16.6583 16.6667 18.3333 13.75 18.3333H6.25835C3.33335 18.3333 2.70002 16.6583 2.95002 14.6083L3.70002 8.35832C3.88335 6.74166 4.16669 5.41666 7.00002 5.41666Z",
    stroke: "#377DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.66699 6.66666V3.74999C6.66699 2.49999 7.50033 1.66666 8.75033 1.66666H11.2503C12.5003 1.66666 13.3337 2.49999 13.3337 3.74999V6.66666M17.0087 14.1917H6.66699",
    stroke: "#377DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingbag);
export default __webpack_public_path__ + "static/media/shoppingbag.6b5627a957dd66578d53f83e895a5170.svg";
export { ForwardRef as ReactComponent };